import { type AxiosError } from 'axios'
import { childResourceForbiddenStore, resolveForbiddenErrorState } from 'shared/child-resource-forbidden-store'
import { isomorphicPush } from 'shared/navigation'

import { clearPaymentProfileSelection } from '~/domains/platform/lib/payment-profile-storage'
import { CHALLENGE_BLOCKED_PTBR } from '~/domains/stone-account/ports/stone-account.routes'
import {
  CHALLENGE_LOCKED,
  KYC_PENDING_REQUEST,
  NEED_VERIFICATION_ERROR,
  SIGN_IN_CHALLENGE_PENDING_APPROVAL,
  USER_IS_BLOCKED
} from '~/lib/constants'

export async function forbiddenInterceptor(error: AxiosError) {
  if ([403, 422].includes(Number(error?.response?.status))) {
    const responseType = (error?.response?.data as any)?.type

    // We're ejecting to avoid console.eror on the challenge approval flow
    if (responseType === SIGN_IN_CHALLENGE_PENDING_APPROVAL) {
      return Promise.reject(error)
    }

    // We're ejecting to avoid console.eror on the otp verification flow
    if (responseType === NEED_VERIFICATION_ERROR) {
      return Promise.reject(error)
    }

    if ([KYC_PENDING_REQUEST, USER_IS_BLOCKED].includes(responseType)) {
      isomorphicPush(`/sair?shouldRedirect=true`, (error as any)?.config?.ctx)

      return Promise.reject(error)
    }

    if ([CHALLENGE_LOCKED].includes(responseType)) {
      isomorphicPush(CHALLENGE_BLOCKED_PTBR, (error as any)?.config?.ctx)

      return Promise.reject(error)
    }

    const forbiddenError = resolveForbiddenErrorState(responseType)
    if (forbiddenError) {
      clearPaymentProfileSelection()

      childResourceForbiddenStore.getState().trigger(forbiddenError)

      return Promise.reject(error)
    }
  }

  return Promise.reject(error)
}
